import React, { useEffect, useMemo, useState } from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import Chart from "../lineChart";
import { defaultSeries, defaulCategories, colorsList } from "../../const";
import loader from "../../../../assets/images/datahub-loader.svg";
import { supplierColors } from "../../const/supplierColorMapping";

const PriceTrendChart = ({
  title = "Pricing Chart",
  series,
  categories,
  isLoading,
  expandTitleLegendGap = false,
}: {
  title?: string;
  series?: any;
  categories?: any;
  isLoading?: boolean;
  expandTitleLegendGap?: boolean;
}) => {
  // const maxRank =
  //   Math.max(...(series ?? [])?.flatMap((s) => s.data.map((d) => d.y))) || 0;
  // const sortedSeries = series
  //   ? [...series].sort((a, b) => a.name.localeCompare(b.name))
  //   : [];

  // const getUniqueRandomColors = (count) => {
  //   const colors = new Set();
  //   const letters = "0123456789ABCDEF";

  //   while (colors.size < count) {
  //     let color = "#";
  //     for (let i = 0; i < 6; i++) {
  //       color += letters[Math.floor(Math.random() * 16)];
  //     }
  //     colors.add(color);
  //   }

  //   return Array.from(colors);
  // };

  // const getLineColors = () => {
  //   // if series is missing, return a single 'black'
  //   if (!series) return ['black'];

  //   return series.map(s => {
  //     // uppercase ID (or undefined) then lookup; default to 'black'
  //     const color = supplierColors[s.supplierId?.toUpperCase()] ?? 'black';
  //     return color;
  //   });
  // };

  // ✅ Generate random colors for sorted series
  // const getLineColors = useMemo(() => {
  //   if (!sortedSeries || sortedSeries.length === 0) return ["black"];
  //   return getUniqueRandomColors(sortedSeries.length);
  //   // return sortedSeries.map(() => getUniqueRandomColors(sortedSeries.length));
  // }, [sortedSeries]);
  // // const getLineColors = useMemo(() => {
  // //   return sortedSeries?.map((s) => getColorFromName(s.name)) ?? ["#000000"];
  // // }, [sortedSeries]);

  //new code
  const maxRank =
    Math.max(...(series ?? [])?.flatMap((s) => s.data.map((d) => d.y))) || 0;

  const sortedSeries = series
    ? [...series].sort((a, b) => a.name.localeCompare(b.name))
    : [];

  // --- 🔹 Step 1: Prepare a shuffled list of colors (once)
  const getShuffledColors = (obj) => {
    const colorValues = Object.values(obj);
    for (let i = colorValues.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [colorValues[i], colorValues[j]] = [colorValues[j], colorValues[i]];
    }
    return colorValues;
  };

  // --- 🔹 Step 2: Store color assignments in state
  const [supplierColorMap, setSupplierColorMap] = useState({});
  // useEffect(() => {
  //   if (!series || series.length === 0) return;

  //   // Only assign new colors if some suppliers don't have one yet
  //   setSupplierColorMap((prevMap) => {
  //     const newMap = { ...prevMap };
  //     const shuffledColors = getShuffledColors(supplierColors);
  //     let colorIndex = 0;

  //     for (const s of series) {
  //       const id = s.supplierId?.toUpperCase();
  //       if (!id) continue;
  //       if (!newMap[id]) {
  //         // Assign next available shuffled color
  //         newMap[id] = shuffledColors[colorIndex % shuffledColors.length];
  //         colorIndex++;
  //       }
  //     }
  //     return newMap;
  //   });
  // }, [series]);

  // useEffect(() => {
  //   if (!series || series.length === 0) return;

  //   setSupplierColorMap((prevMap) => {
  //     const newMap = { ...prevMap };

  //     // All unique colors available
  //     const allColors = Object.values(supplierColors);

  //     // Track used colors
  //     const usedColors = new Set(Object.values(newMap));

  //     // Filter out already-used colors and shuffle the rest
  //     const availableColors = allColors
  //       .filter((color) => !usedColors.has(color))
  //       .sort(() => Math.random() - 0.5);

  //     let colorIndex = 0;

  //     for (const s of series) {
  //       const id = s.supplierId?.toUpperCase();
  //       if (!id) continue;

  //       // Assign a color only if not already assigned
  //       if (!newMap[id]) {
  //         // If all colors are used, start reusing (but this rarely happens)
  //         const color =
  //           availableColors[colorIndex] ??
  //           allColors[colorIndex % allColors.length];
  //         newMap[id] = color;
  //         usedColors.add(color);
  //         colorIndex++;
  //       }
  //     }

  //     return newMap;
  //   });
  // }, [series]);

  const shuffledBaseColors = useMemo(() => {
    const colors = [...Object.values(supplierColors)];
    for (let i = colors.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [colors[i], colors[j]] = [colors[j], colors[i]];
    }
    return colors;
  }, []);

  useEffect(() => {
    if (!series?.length) return;

    setSupplierColorMap((prevMap) => {
      // 1️⃣ Keep only suppliers still present in current data
      const newMap = Object.fromEntries(
        Object.entries(prevMap).filter(([id]) =>
          series.some((s) => s.supplierId?.toUpperCase() === id)
        )
      );

      // 2️⃣ Track colors already used
      const usedColors = new Set(Object.values(newMap));
      let colorIndex = 0;

      // 3️⃣ Assign colors to any new suppliers
      for (const s of series) {
        const id = s.supplierId?.toUpperCase();
        if (!id) continue;

        // If this supplier doesn't have a color yet
        if (!newMap[id]) {
          const availableColor =
            // Use the first unused color from the shuffled palette
            shuffledBaseColors.find((c) => !usedColors.has(c)) ??
            // Fallback: reuse colors if palette runs out
            shuffledBaseColors[colorIndex % shuffledBaseColors.length];

          newMap[id] = availableColor;
          usedColors.add(availableColor);
          colorIndex++;
        }
      }

      return newMap;
    });
  }, [series, shuffledBaseColors]);

  // const colorsList = getLineColors;
  const colorsList = useMemo(() => {
    if (!sortedSeries || sortedSeries.length === 0) return ["#000000"];
    return sortedSeries.map(
      (s) => supplierColorMap[s.supplierId?.toUpperCase()] ?? "#000000"
    );
  }, [sortedSeries, supplierColorMap]);
  if (isLoading != false) {
    return (
      <>
        <h4 className="text-center">{title}</h4>
        <div
          className="d-flex justify-content-center align-items-center mt-5 mb-5"
          style={{ height: "400px" }}
        >
          <img src={loader} height={"100px"} alt="Loading" />
        </div>
        <hr />
      </>
    );
  }

  // if (!series || series.length === 0 || !categories || categories.length === 0) {
  if (
    !sortedSeries ||
    sortedSeries.length === 0 ||
    !categories ||
    categories.length === 0
  ) {
    return (
      <>
        <h4 className="text-center">{title}</h4>
        <div
          className="d-flex justify-content-center align-items-center mt-5 mb-5"
          style={{ height: "400px" }}
        >
          No data available for the selected filters!
        </div>
        <hr />
      </>
    );
  }

  //   const options: ApexOptions = {
  //     chart: {
  //       height: '500px', // Set height to 60% of the viewport height
  //       width: '100%',  // Set width to 100% of the container
  //       // type: 'mixed',
  //       zoom: {
  //         enabled: false
  //       },
  //       toolbar: {
  //         show: false
  //       },
  //       animations: {
  //         enabled: false,
  //         easing: 'linear',
  //         speed: 0,
  //         animateGradually: { enabled: false },
  //         dynamicAnimation: { enabled: false, speed: 0 }
  //       }
  //     },
  //     colors: colorsList,
  //     // [
  // //   "#f58231", // Orange
  // //   "#e6194b", // Red
  // //   "#3cb44b", // Green
  // //   "#ffe119", // Yellow
  // //   "#0082c8", // Blue
  // //   "#911eb4", // Purple
  // //   "#46f0f0", // Cyan
  // //   "#f032e6", // Magenta
  // //   "#d2f53c", // Lime
  // //   "#fabebe", // Pink
  // //   "#008080", // Teal
  // //   "#e6beff", // Lavender
  // //   "#aa6e28", // Brown
  // //   "#fffac8", // Beige
  // //   "#800000", // Maroon
  // //   "#aaffc3", // Mint
  // //   "#808000", // Olive
  // //   "#ffd8b1", // Apricot
  // //   "#000080", // Navy
  // //   "#808080", // Gray
  // //   "#4b0082", // Indigo
  // //   "#b22222", // Firebrick
  // //   "#00ff00", // Bright Green
  // //   "#0000ff", // Bright Blue
  // //   "#ff00ff", // Bright Magenta
  // //   "#00ffff", // Bright Cyan
  // //   "#ffff00", // Bright Yellow
  // //   "#800080", // Dark Purple
  // //   "#008000", // Dark Green
  // //   "#ffa500"  // Dark Orange
  // // ],

  //     // [
  //     //   '#FEB019',
  //     //   '#00E396',
  //     //   '#008FFB',
  //     //   '#2F4F4F',
  //     //   '#8A2BE2', // BlueViolet
  //     //   '#20B2AA',  // LightSeaGreen
  //     //   '#1E90FF', // Blue
  //     //   '#FF6347', // Red (Tomato)
  //     //   '#32CD32', // Green (LimeGreen)
  //     //   '#8A2BE2', // BlueViolet
  //     //   '#FF1493', // DeepPink
  //     //   '#FFA500', // Orange
  //     //   '#FFD700', // Gold
  //     //   '#00FA9A', // MediumSpringGreen
  //     //   '#FF4500', // OrangeRed

  //     // ],
  //     // dataLabels: {
  //     //   enabled: false,
  //     //   formatter: function(val, opts) {
  //     //     console.log('formatter:', opts.w.globals.seriesNames[opts.seriesIndex]);
  //     //     return val + ' - ' + opts.w.globals.seriesNames[opts.seriesIndex];
  //     //   },
  //     //   style: {
  //     //     fontSize: '10px',
  //     //     colors: [
  //     //       '#1E90FF', // Blue
  //     //       '#FF6347', // Red (Tomato)
  //     //       '#32CD32', // Green (LimeGreen)
  //     //       '#8A2BE2', // BlueViolet
  //     //       '#FF1493', // DeepPink
  //     //       '#FFA500', // Orange
  //     //       '#FFD700', // Gold
  //     //       '#00FA9A', // MediumSpringGreen
  //     //       '#FF4500', // OrangeRed
  //     //       '#20B2AA'  // LightSeaGreen
  //     //     ]
  //     //   },
  //     // },
  //     stroke: {
  //       width: 3,
  //       curve: 'smooth',
  //       // dashArray: [0,5,5,5,5,5,5,5,5,5,5,5]
  //     },
  //     title: {
  //       text: title,
  //       align: 'center'
  //     },
  //     legend: {
  //       // tooltipHoverFormatter: function(val, opts) {
  //       //   return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
  //       // },
  //       position: 'top',
  //       horizontalAlign: 'right',
  //       // floating: true,
  //       offsetY: -25,
  //       offsetX: -5
  //     },
  //     markers: {
  //       size: 4,
  //       colors:['#fff'],
  //       strokeColors: '#000000',
  //       strokeWidth: 1,
  //     },
  //     xaxis: {
  //       categories: categories,
  //       title: {
  //         text: ''
  //       }
  //     },
  //     yaxis: {
  //       title: {
  //         text: 'Price ($)'
  //       },
  //       // min: 0,
  //       // max: 0.5,
  //       // tickAmount: 10
  //     },
  //     // plotOptions: {
  //     //   bar: {
  //     //     columnWidth: '75%',
  //     //     //distributed: true,
  //     //     //horizontal: false,
  //     //   }
  //     // }
  //   };

  const options: ApexOptions = {
    chart: {
      height: "500px",
      width: "100%",
      zoom: { enabled: false },
      toolbar: { show: false },
      animations: { enabled: false },
    },
    colors: colorsList,
    stroke: {
      width: 3,
      curve: "smooth",
    },
    title: {
      text: title,
      align: "center",
    },
    legend: {
      showForSingleSeries: true,
      position: "top",
      horizontalAlign: "right",
      offsetY: expandTitleLegendGap ? 18 : -25,
      offsetX: -5,
    },
    markers: {
      size: 4,
      colors: ["#fff"],
      strokeColors: "#000000",
      strokeWidth: 1,
      hover: {
        size: 6, // absolute size on hover
        // sizeOffset: 1   // expansion difference (smaller than default 3)
      },
    },
    xaxis: {
      categories: categories,
      title: { text: "" },
    },
    yaxis: {
      title: { text: "Rank" },
      min: 1, // lowest rank
      max: maxRank, // highest rank
      forceNiceScale: true,
      tickAmount: maxRank - 1,
      // tickAmount: 25,  // how many ticks to show (adjust depending on max rank)
    },

    tooltip: {
      shared: false,
      intersect: true,
      fixed: {
        enabled: false,
        position: "topLeft", // 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'
        offsetX: 0,
        offsetY: -0,
      },
      custom: function ({ seriesIndex, dataPointIndex, w }) {
        const s = w.globals.initialSeries[seriesIndex];
        const point = s.data[dataPointIndex];

        if (!point) return "";

        const supplier = s.name;
        const color = w.globals.colors[seriesIndex];
        const date = w.globals.categoryLabels[dataPointIndex];

        const currPrice = point.currPrice ?? "-";

        // helper for color coding
        const formatVariance = (val) => {
          if (
            val === null ||
            val === undefined ||
            val === "" ||
            isNaN(Number(val))
          ) {
            return `<span style="color:#999">--</span>`;
          }
          // const num = Number(val);
          // if (num < 0) return `<span style="color:green">${num}</span>`;
          // if (num > 0) return `<span style="color:red">+${num}</span>`;
          return `<span style="color:#666">${val}</span>`;
        };

        return `
      <div class="apex-tooltip p-2" style="background:rgba(255,255,255,0.9); border-radius:8px;">
        <div class="fw-bold mb-2">
          <span style="
            display:inline-block;
            width:10px;
            height:10px;
            border-radius:50%;
            background:${color};
            margin-right:6px;">
          </span>
          ${supplier} - ${date}
        </div>
        
        <div class="fw-bold mb-1">Price Variance:</div>
        <table style="width:100%; border-collapse:collapse; font-size:12px;">
          <tr>
            <td style="padding:2px 6px;">Best Price</td>
            <td style="text-align:right; padding:2px 6px;">${formatVariance(
              point.deltaBest
            )}</td>
          </tr>
          <tr>
            <td style="padding:2px 6px;">Next Better Price</td>
            <td style="text-align:right; padding:2px 6px;">${formatVariance(
              point.deltaNextBetter
            )}</td>
          </tr>
          <tr>
            <td style="padding:2px 6px;">Next Worse Price</td>
            <td style="text-align:right; padding:2px 6px;">${formatVariance(
              point.deltaNextWorse
            )}</td>
          </tr>
          <tr>
            <td style="padding:2px 6px;">Worst Price</td>
            <td style="text-align:right; padding:2px 6px;">${formatVariance(
              point.deltaWorst
            )}</td>
          </tr>
        </table>
      </div>
    `;
      },
    },
  };

  return <Chart options={options} series={sortedSeries} height="500px" />;
};

export default PriceTrendChart;
